import { render, staticRenderFns } from "./studyclassDetail.vue?vue&type=template&id=d67f43cc&scoped=true&"
import script from "./studyclassDetail.vue?vue&type=script&lang=js&"
export * from "./studyclassDetail.vue?vue&type=script&lang=js&"
import style0 from "./studyclassDetail.vue?vue&type=style&index=0&id=d67f43cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d67f43cc",
  null
  
)

export default component.exports